var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.faqItems.length
    ? _c("div", { staticClass: "faq-section" }, [
        _c("h2", [
          _vm._v("\n    FAQs\n    "),
          _c(
            "span",
            { staticClass: "toggle", on: { click: _vm.handleToggle } },
            [_vm._v("\n      " + _vm._s(this.expanded ? "▲" : "▼") + "\n    ")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "container content",
            class: { visible: this.expanded }
          },
          _vm._l(_vm.faqItems, function(faq, index) {
            return _c("div", { key: index, staticClass: "question-block" }, [
              _c("h4", { domProps: { textContent: _vm._s(faq.question) } }),
              _vm._v(" "),
              _c("div", {
                staticClass: "faq-answer",
                domProps: { innerHTML: _vm._s(faq.answer) }
              })
            ])
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }